// extracted by mini-css-extract-plugin
export default {"buttons":"BasketExpirationInterstitial_buttons__IP82Z","header":"BasketExpirationInterstitial_header__+flL3","icon":"BasketExpirationInterstitial_icon__ljyk8"};